//**This is the SibsForever sidebar for Wall

import isEmpty from 'lodash/isEmpty'
import { getHeaderText } from '../functions/location_fcns'
import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react'
import usePagePerms from '../hooks/usePagePerms'
import { NavLink } from 'react-router-dom';
import { Menu } from 'react-bulma-components';
import AllSettings from '../common/AllSettings'
import PageHelp from '../common/help/PageHelp'

const helpHtml='<p><img src="https://sibsforever.org/img/wall/wall-sidebar.png" alt="Wall Sidebar" width="205" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="229"></p><p><span><strong><br></strong></span></p><p><span><strong><br></strong></span></p><p><span><strong><br></strong></span></p><p><span><strong><br></strong></span></p><p><span><strong>1) Select New Entry to Add add a new post to the Wall</strong></span></p><p><img src="https://sibsforever.org/img/getting-started/wall-entry.png" alt="" width="921" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="319"></p><p><span> <br clear="all">a)&nbsp; Just <strong>enter the title and memory, and optionally include a photo or video (uploaded or selected from your Picture or Video Gallery).</strong>&nbsp; Everything is <strong>automatically saved.</strong>&nbsp; You can<strong> paste content</strong>&nbsp;into these fields if you have this content elsewhere (e.g., Word, PDF or HTML)</span></p><p><span>b)&nbsp;Select </span><span><strong>Post Entry</strong> </span><span>to add the new post&nbsp; to you wall</span></p><p><br></p><p><strong>2</strong>) <strong>Edit the posting and/or change the photo/video</strong></p><p><img src="https://sibsforever.org/img/getting-started/wall-buttons.png" alt="Wall Edit buttons" width="914" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="43"></p><p><br clear="all"><span>&nbsp;<strong>Share Settings</strong> controls who can see the individual post</span></p><ul><li><span>You can <strong>share this entry with all SibsForever users </strong>to make the post visible to the<strong> SibsForever community</strong></span></li><li><span>Or you can select options to <strong>restrict access to this specific post</strong></span></li></ul>'

const helpHeading = "Remembrance Wall Help"

const WallSidebar = () => {  

const styles = {
    hrStyle: { borderTop: "2px solid #bbb" },
    spanStyle: { marginRight: "2px", marginTop:"5px", marginBottom:"5px" }
}

   const [ canAdmin, canEdit, canView, isResolved ] = usePagePerms('wall', 'singleton')

   const [ editLinks, setEditLinks ] = useState("")
   const [ viewLinks, setViewLinks ] = useState("")
   const [ adminLinks, setAdminLinks ] = useState("")

   const [ isInit, setIsInit ] = useState(false)
   const user = useSelector(state => state.user);

   useEffect(() => {
      if (isResolved && !isEmpty(user) || !isEmpty(user.email))
      {
          if (canEdit) setEditLinks(
             <>
             <div><NavLink className="xmenu-block" activeClassName="is-active" to="/auth/wall/edit">
	         <span className="nospace"><span className="menu-icon">
	         <i className="fa fa-edit"  style={styles.spanStyle}></i>
	         </span>
	         Edit</span>
	         </NavLink></div>
	         <div><NavLink className="xmenu-block" activeClassName="is-active" to="/auth/wall/new">
               <span className="nospace"><span className="menu-icon">
                 <i className="fa fa-plus"  style={styles.spanStyle}></i>
               </span>
              New Entry </span>
             </NavLink></div>
             </>
             )
         if (canView) setViewLinks(
            <div><NavLink className="xmenu-block" activeClassName="is-active" to="/auth/wall/view">
	        <span className="nospace"><span className="menu-icon">
	          <i className="fa fa-eye"  style={styles.spanStyle}></i>
	       </span>
	       Preview</span>
	       </NavLink></div>
           )
         if (canAdmin) setAdminLinks(
             <>
             <hr className="is-hidden-mobile" style={styles.hrStyle} />
             <AllSettings pageType='wall' pageInstance='singleton' toLink='/auth/wall/settings'/>
             </>
             )

         setIsInit(true);
      }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ isResolved, canEdit, canAdmin, canView ])

    if (!isInit)
     return <div>Loading...</div>

    const help = canEdit?<PageHelp header={helpHeading} body={helpHtml}/>
                        : ""

    return (
  
  <Menu>
     <p className="menu-label is-hidden-mobile">{getHeaderText()}{help}</p>
        {editLinks}
<hr className="is-hidden-mobile" style={styles.hrStyle} />
        {viewLinks}
        {adminLinks}
  </Menu>

    )
  }

export default WallSidebar

